import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Header from "./components/site/Header";
import Footer from "./components/site/Footer";
import WhatsAppButton from "./components/site/WhatsAppButton";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./pages/HomePage";
import NotFoundPage from "./pages/NotFoundPage";
import PoliticaPrivacidadePage from "./pages/PoliticaPrivacidadePage";
import ServiceLandingPage from "./pages/ServiceLandingPage";
import FinanciamentoPage from "./pages/FinanciamentoPage";
import ConsentBanner from "./components/site/ConsentBanner";
import DebugOverlay from "./components/site/DebugOverlay";
import { SERVICE_LANDING } from "./lib/serviceLanding";
import { initGA } from "./lib/analytics";
import { initConsentDefaults } from "./lib/consent";
import { bindMetaPixelToConsent } from "./lib/metaPixel";
import { captureUtms } from "./lib/utms";

function App() {
  useEffect(() => {
    // Order matters: 1) push consent defaults, 2) load gtag, 3) capture UTMs (idempotent).
    initConsentDefaults();
    initGA();
    bindMetaPixelToConsent();
    captureUtms();
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/politica-privacidade" element={<PoliticaPrivacidadePage />} />
            <Route path="/financiamento" element={<FinanciamentoPage />} />
            <Route path="/implantes-dentarios-portimao" element={<ServiceLandingPage content={SERVICE_LANDING.implantes} />} />
            <Route path="/alinhadores-invisiveis-portimao" element={<ServiceLandingPage content={SERVICE_LANDING.alinhadores} />} />
            <Route path="/estetica-reabilitacao-portimao" element={<ServiceLandingPage content={SERVICE_LANDING.estetica} />} />
            <Route path="/ortodontia-portimao" element={<ServiceLandingPage content={SERVICE_LANDING.ortodontia} />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
        <ConsentBanner />
        <Toaster position="top-right" />
        <DebugOverlay />
      </BrowserRouter>
    </div>
  );
}

export default App;
